import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import InfiniteScroll from "./infiniteScroll";
import { makeStyles } from "@material-ui/core/styles";
import { subsImages } from "../enums";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,
  },
  image: {
    padding: 2,
    "& img": {
      maxWidth: "100%",
      maxHeight: "100%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      position: "relative",
    },
  },
}));

export default () => {
  const classes = useStyles();
  const imagesPerLoad = 12;
  const scrollThreshold = 0.7;

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        Gallery
      </Typography>
      <Grid container>
        <InfiniteScroll
          {...{
            items: subsImages,
            loadMoreAmount: imagesPerLoad,
            threshold: scrollThreshold,
          }}
        >
          {(currentSubsImages) =>
            currentSubsImages.map((subsImage, index) => (
              <Grid key={index} item xs={12} sm={4} className={classes.image}>
                {/* eslint-disable-next-line */}
                <img src={subsImage} />
              </Grid>
            ))
          }
        </InfiniteScroll>
      </Grid>
    </>
  );
};
